import { SUPPORTED_CHAIN_IDS } from '@shared/wallet/constants/chain'

import type { SupportedChainId } from '@shared/wallet/constants/chain'

export const isSupportedChainId = (
  chainId: number | null | undefined,
): chainId is SupportedChainId => {
  if (chainId == null) {
    return false
  }

  return SUPPORTED_CHAIN_IDS.includes(chainId)
}
